import { getRemainingDays } from '../utils/utilities';
import { getMyParts } from '../utils/parts';

/**
 * The upcoming services the user has a part in, soonest first, each with the songs they're on, where
 * each sits in the service, and their parts in it. Positions count only the songs the team still has,
 * as the service card's list does, so a jump from either lands on the same song.
 */
export const getAssignedServices = (services, songs, userId) =>
  services
    .filter((service) => getRemainingDays(service.date) >= 0)
    .map((service) => ({
      service,
      entries: service.songsIds
        .map((songId) => songs.find((song) => song._id === songId))
        .filter(Boolean)
        .map((song, i) => ({ song, i, parts: getMyParts(song, userId) }))
        .filter(({ parts }) => parts.length > 0),
    }))
    .filter(({ entries }) => entries.length > 0)
    .sort((a, b) => new Date(a.service.date) - new Date(b.service.date));
